import { WORLD_GENERATION_SEED, getWorldHeightAt, getWorldRiverCenterAt, getWorldRiverProfileAt, getWorldRiverWaterHeightAt, } from "./world-generation.js";
/** Preserve the river reference in its core; its bounded fringe meets the riverbed.
 * The outer extent is the existing Generation V2 river influence envelope. */
export const WORLD_WATER_CORE_HALF_WIDTH_FACTOR = 0.95;
export const WORLD_WATER_HALF_WIDTH_FACTOR = 1.45;
export const WORLD_WATER_CURRENT_SPEED = 0.35;
/** Fixed work per query; shares the original river course, height and terrain. */
export function sampleWorldWaterAt(x, z, seed = WORLD_GENERATION_SEED) {
    const river = getWorldRiverProfileAt(x, z, seed);
    const terrainY = getWorldHeightAt(x, z, seed);
    const meanY = getWorldRiverWaterHeightAt(x, z, seed);
    const distanceRatio = river.distance / river.width;
    const fringe = Math.max(0, Math.min(1, (distanceRatio - WORLD_WATER_CORE_HALF_WIDTH_FACTOR) / (WORLD_WATER_HALF_WIDTH_FACTOR - WORLD_WATER_CORE_HALF_WIDTH_FACTOR)));
    const bankBlend = fringe * fringe * (3 - 2 * fringe);
    // Existing terrain can dip beyond a bend or in a low macro biome. Meeting the
    // bed continuously prevents a deep-to-dry step at the bounded ribbon edge.
    const surfaceY = fringe >= 1 ? terrainY : meanY + (terrainY - meanY) * bankBlend;
    const distanceFromBank = Math.max(0, river.width * WORLD_WATER_HALF_WIDTH_FACTOR - river.distance);
    const depth = Math.max(0, surfaceY - terrainY);
    const inside = depth > 0;
    const tangentX = getWorldRiverCenterAt(z + 0.5, seed) - getWorldRiverCenterAt(z - 0.5, seed);
    const tangentLength = Math.hypot(tangentX, 1);
    return {
        inside, surfaceY, terrainY, depth,
        flowDirectionX: tangentX / tangentLength, flowDirectionZ: 1 / tangentLength,
        flowSpeed: inside ? WORLD_WATER_CURRENT_SPEED : 0,
        distanceFromBank,
    };
}
